import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class YBKycGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isUserKYCDone = localStorage.getItem('yesBankEkycStatus');    
    if (isUserKYCDone=='TRUE') {
      return true;
      
    }else{
      this.router.navigate(['yes-bank-ekyc']);
      return false;
      
     }
  }
  // serviceprovider = [
    //   { 'img': 'https://images.vartulz.com/Yesbank.png', 'bank_name': 'YES Bank' }
    // , { 'img': 'https://images.vartulz.com/ICICI.png', 'bank_name': 'ICICI Bank' }
    //   ]
}
